import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const i = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M476.55 108.49v21.727c-130.325 10.347-218.946 86.909-218.946 197.617 0 116.915 70.897 173.82 223.117 213.137v203.823c-57.342-10.345-105.303-34.142-154.304-69.321-9.385-7.243-21.897-11.381-34.406-11.381-32.322 0-57.344 24.832-57.344 56.907 0 21.726 10.426 38.281 28.149 49.662 63.601 44.491 135.539 72.425 213.734 80.702v64.149c0 24.83 20.853 44.489 45.875 44.489 25.024 0 44.832-19.659 44.832-44.489v-62.08c132.412-12.416 222.076-87.945 222.076-201.756 0-110.705-67.77-173.82-226.246-213.135V239.889c35.45 8.277 70.897 23.797 107.39 45.525 10.426 6.206 20.851 9.31 31.277 9.31 32.322 0 58.387-24.83 58.387-56.905 0-24.831-14.596-40.351-31.279-49.663-47.959-30.005-100.09-49.663-161.604-56.905v-22.762c0-24.831-19.808-44.49-44.832-44.49-25.022 0-45.875 19.658-45.875 44.49zm189.756 550.428c0 49.664-36.491 82.771-103.219 90.014V560.627c80.282 24.832 103.219 52.768 103.219 98.291M380.631 320.591c0-45.523 33.363-80.702 100.09-86.91v183.132c-80.279-25.867-100.09-52.766-100.09-96.222",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = r(i);
export {
  s as default
};
